import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=455f1dd2&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=455f1dd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455f1dd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455f1dd2')) {
      api.createRecord('455f1dd2', component.options)
    } else {
      api.reload('455f1dd2', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=455f1dd2&scoped=true&", function () {
      api.rerender('455f1dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NMV1k2jn78Dy/JS/comp/SearchFilterTokens.vue"
export default component.exports